export enum TrackerDependencyType {
    FORMULA = "FORMULA",
    INDEPENDENT = "INDEPENDENT"
}